module.exports = __webpack_public_path__ + "2c6add4fe59b94fb7968a6c9a44fcbdd.svg";